import { Tags } from 'rbh-merchant-core';
import { FoodCategory } from './food-category';
export interface MenuDiscount {
  menuDiscountId: number;
  priceDiscount: number;
  menuDiscountStatus: string;
  startDate: string;
  endDate?: string | null;
}
export class FoodMenu {
  menuId?: number;
  menuName?: string;
  menuNameEN?: string;
  menuSKUId?: string;
  menuDescription?: string;
  menuDescriptionEN?: string;
  menuOriginalPrice?: number;
  menuPhoto?: string;
  menuPrice?: number;
  menuStatus?: string;
  menuQCStatus?: string;
  menuQCUpdatedDate?: string;
  menuRejectReason?: [];
  menuCategory?: FoodCategory;
  menuDiscounts?: MenuDiscount[];
  tagId?: number;
  tag?: Tags;

  constructor(Obj: any = {}) {
    this.menuId = Obj.menuId;
    this.menuName = Obj.menuName;
    this.menuNameEN = Obj.menuNameEN;
    this.menuSKUId = Obj.menuSKUId;
    this.menuDescription = Obj.menuDescription;
    this.menuDescriptionEN = Obj.menuDescriptionEN;
    this.menuOriginalPrice = Obj.menuOriginalPrice;
    this.menuPhoto = Obj.menuPhoto;
    this.menuPrice = Obj.menuPrice;
    this.menuStatus = Obj.menuStatus;
    this.menuQCStatus = Obj.menuQCStatus;
    this.menuQCUpdatedDate = Obj.menuQCUpdatedDate;
    this.menuRejectReason = Obj.menuRejectReason;
    this.menuCategory = Obj.menuCategory;
    this.menuDiscounts = Obj.menuDiscounts;
    this.tagId = Obj.tagId;
    this.tag = Obj.tag;
  }
}


export interface FoodMenuType {
    menuId: number;
    tagId: number;
    menuSequence: number;
    menuName: string;
    menuNameEN: string
    menuSKUId: string;
    menuDescription: string;
    menuDesriptionEN: string;
    menuPhotoUrl: string;
    menuPrice: number;
    menuOriginalPrice: number;
    menuStatus: string;
    menuQcStatus: string;
    menuRejectReason: string[]
    qcUpdatedAt: string;
    menuCategory: MenuCategory;
    menuDiscounts: MenuDiscount[];
    isHideMenu: boolean;
    isOffline: boolean;
    startDate: string;
    endDate: string;
    menuPhoto?: string;
}

export interface MenuCategory {
    menuCategoryId: number;
    menuCategoryTypeId: number;
    menuCategoryName: string;
    menuCategoryNameEn: string;
    menuCategoryStatus: string
}